import { createClient } from "@supabase/supabase-js";

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";
export const isConfigured = supabaseUrl.startsWith("https://") && supabaseAnonKey.length > 20;

const noStoreFetch: typeof fetch = (input, init) => fetch(input, { ...init, cache: "no-store" });

export const supabase = createClient(
  supabaseUrl || "https://unconfigured.invalid",
  supabaseAnonKey || "unconfigured",
  {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    global: { fetch: noStoreFetch }
  }
);
